import React, { useRef } from 'react';

import { resumeSmartImportService } from 'services/cv';
import { useMutation } from 'react-query';
import { getErrorText } from 'utils/geterrortext';
import ActionButton from '@core/components/actionbutton/ActionButton';

import classes from './ImportResume.module.scss';


const ImportResume = ({ toast, onUploadResumeSuccess, setResumeStatus }) => {
    const fileInputRef = useRef(null);

    const { mutate, isLoading, error } = useMutation(resumeSmartImportService.POST, {
        onSuccess: (data) => {
            toast(
                'Resume imported successfully. We are processing the file and will update your profile shortly.',
                'success'
            );
            onUploadResumeSuccess();
            setResumeStatus(data?.data?.status);
        },
        onError: (error) => {
            let errorMessage = getErrorText(error);
            // Handle nested error format: {"status":"error","data":{"resume":["Unsupported file extension."]}}
            if (!errorMessage && error?.response?.data?.data?.resume?.[0]) {
                errorMessage = error.response.data.data.resume[0];
            }
            toast(
                errorMessage || 'An error occurred while importing your resume',
                'alert'
            );
        }

    });

    const handleImport = () => {
        if (fileInputRef.current) fileInputRef.current.click();
    };

    const onFileChange = (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('resume', file, file.name);
        mutate(formData);
    };

    return (
        <div className={classes.wrapper}>
            <h2>Your resume stays in your control </h2>
            <div className={classes.content}>
                <p>
                    We'll use AI to instantly read your resume and fill in your profile — so you skip the manual typing. You review everything before it's saved.

                </p>
                <p>
                    ✦ Your data is processed securely and not stored beyond this session
                    < br />
                    ✦ Nothing is shared publicly — this only populates your draft profile
                </p>
                <p className={classes.notice}>
                    By continuing, you confirm you have the right to share this document.
                </p>
                <div className='d-flex justify-content-center mt-5'>
                    <ActionButton onClick={handleImport} loading={isLoading}>
                        Import Resume
                    </ActionButton>
                </div>
            </div>

            <input
                ref={fileInputRef}
                type="file"
                accept=".pdf,.doc,.docx,.txt"
                style={{ display: 'none' }}
                onChange={onFileChange}
            />
        </div>
    );
};

export default ImportResume;